import cacheIcon from './categories/cache.svg';
import checkpointIcon from './categories/checkpoint.svg';
import conflictIcon from './categories/conflict.svg';
import crashIcon from './categories/crash.svg';
import criminalIcon from './categories/criminal.svg';
import engagementIcon from './categories/engagement.svg';
import hazardIcon from './categories/hazard.svg';
import iedIcon from './categories/ied.svg';
import illegalParkingIcon from './categories/illegal_parking.svg';
import observationIcon from './categories/observation.svg';
import publicDisruptionIcon from './categories/public_disruption.svg';
import sabotageIcon from './categories/sabotage.svg';
import surveillanceIcon from './categories/surveillance.svg';
import threatIcon from './categories/threat.svg';
import uasIcon from './categories/uas.svg';

const getCategoryIcon = (category) =>
  ({
    cache: cacheIcon,
    checkpoint: checkpointIcon,
    conflict: conflictIcon,
    crash: crashIcon,
    criminal: criminalIcon,
    engagement: engagementIcon,
    hazard: hazardIcon,
    ied: iedIcon,
    illegal_parking: illegalParkingIcon,
    observation: observationIcon,
    public_disruption: publicDisruptionIcon,
    sabotage: sabotageIcon,
    surveillance: surveillanceIcon,
    threat: threatIcon,
    uas: uasIcon,
  })[category];

export default getCategoryIcon;
